<div class="flex-column">
    <span class="headline-1 mbs-5 text-primary-darker-title">
        {{ titleComponent  }}
    </span>
    <div class="flex-column">
        <div class="flex-column border-filters pb-2">
            <!-- Filters -->
            <form class="flex-100 flex-column mts-3"
                *ngIf="!(this.isLoadingGettingFinanciers) && !!this.filterForm && !!this.financiers"
                [formGroup]="filterForm">

                <!-- Top filters -->
                <div class="flex-row align-space-evenly-center">
                    <div class="flex-column flex-20">
                        <span class="subtitle-4 text-primary-darker">
                            {{'modules.schedule.provisional-control.filters.financier' | exp:'':'Financiador'}}
                        </span>
                        <app-multi-select-searching-input [form]="this.filterForm" [elements]="(this.financiers)"
                            [calculateId]="this.calculateIdFinancier" [calculateName]="this.calculateNameFinancier"
                            [spinner]=false
                            [placeholder]="('modules.schedule.provisional-control.filters.placeholders.select' | exp:'':'Seleccionar')" [name]="this.FINANCIER"
                            (selected)="onSelectFinancier($event)">
                        </app-multi-select-searching-input>
                    </div>
                    <div class="flex-column flex-20">
                        <span class="subtitle-4 text-primary-darker">
                            {{ 'modules.schedule.provisional-control.filters.company-type' | exp:'':'Tipo de empresa' }}
                        </span>
                        <app-multi-select-searching-input [form]="this.filterForm" [elements]="(this.companyTypesList)"
                            [calculateId]="this.calculateIdCompanyType" [calculateName]="this.calculateNameCompanyType"
                            [spinner]=false
                            [placeholder]="!!companyTypesList && companyTypesList.length > 0 ? ('modules.schedule.provisional-control.filters.placeholders.select' | exp:'':'Seleccionar') : ('modules.schedule.provisional-control.filters.placeholders.all' | exp:'':'-- Todos --')"
                            [name]="this.COMPANY_TYPE">
                        </app-multi-select-searching-input>
                    </div>
                    <div class="flex-column flex-20">
                        <span class="subtitle-4 text-primary-darker">
                            {{'modules.schedule.provisional-control.filters.operator' | exp:'':'Operador/a'}}
                        </span>
                        <!-- [defaultValue]="!!this.metaDataCases && this.metaDataCases.operatorId ? this.metaDataCases.operatorId : this.user.id" -->
                        <app-select-searching-input [name]="this.OPERATOR" [nameSearching]="this.OPERATOR_SEARCHING"
                            [form]="this.filterForm"
                            [placeholder]="('modules.schedule.provisional-control.filters.placeholders.select' | exp:'':'Seleccionar')" [elements]="this.operators"
                            [defaultValue]="!!this.operator ? this.operator : null"
                            [calculateId]="this.calculateIdOperator" [calculateName]="this.calculateNameOperator"
                            [placeholderNoValue]="('modules.schedule.provisional-control.filters.placeholders.no-results' | exp:'':'Sin resultados')"
                            [placeholderSearching]="('modules.schedule.provisional-control.filters.placeholders.search' | exp:'':'Buscar...')"
                            [noOptionText]="('modules.schedule.provisional-control.filters.placeholders.all' | exp:'':'-- Todos --')"
                            [ngStyle]="this.getSelectedOperator()?.active === false ? {'opacity': '0.6'} : {}">
                        </app-select-searching-input>
                    </div>
                    <div class="flex-column flex-20">
                        <span class="subtitle-4 text-primary-darker">
                            {{ 'modules.schedule.provisional-control.filters.until' | exp:'':'Hasta' }} ( {{this.getPeriod()}} )
                        </span>
                        <div (keydown)="handleKeyDown($event)">
                            <app-date-picker #datePicker [name]="DATE_TO" [form]="filterForm">
                            </app-date-picker>
                        </div>
                    </div>
                </div>

                <!-- <div class="flex-row flex-wrap align-center-start flex-20" style="font-size: 12px !important">
                </div> -->

                <!-- Filter buttons -->
                <div class="flex-row align-center-center gap-5em">
                    <div class="end-center">
                        <button mat-stroked-button [color]="'primary'" (click)="this.resetFilters()">{{ 'modules.schedule.provisional-control.filters.clear' | exp:'':'Borrar filtros' }}</button>
                    </div>
                    <div class="align-start-center">
                        <button mat-raised-button [color]="'primary'"
                            (click)="onFilterV2FromButton(true, 'v2')">{{ ('modules.schedule.provisional-control.filters.filter' | exp:'':'Filtrar')  }}</button>
                    </div>
                    <!-- <div class="align-start-center">
                        <button mat-raised-button [color]="'primary'" *ngIf="!environment.production || (environment.production && this.user.id == 100000633)" (click)="onFilterV2FromButton(true, 'v2')">{{ 'modules.schedule.provisional-control.filters.filter-v2' | exp:'':'Filtrar v2' }}</button>
                    </div> -->
                </div>
            </form>
        </div>

        <!-- Center cards -->
        <div class="flex-row align-stretch-stretch border-indicators"> <!-- Comment: style="height: 36vh;" -->
            <!-- First card -->
            <div class="flex-column align-center-center border-right" style="flex: 0.5"
                (click)="!this.isLoadingProvisionalControlIndicators ? this.onClickCardIndicator(this.casesStates[1].name) : null"
                [ngStyle]="{'cursor': this.isLoadingProvisionalControlIndicators ? 'default' : 'pointer'}">
                <span class="mat-display-1 number-font big-number mb-0 mxs-2 label-2"
                    *ngIf="!this.isLoadingProvisionalControlIndicators; else loadingIndicators">
                    {{ counterTotalIndicator }}
                </span>
                <span class="text-primary-darker subtitle-1">{{ 'modules.schedule.provisional-control.indicators.total-cases' | exp:'':'Total casos' }}</span>
                <span class="text-primary subtitle-1">{{ ('modules.schedule.provisional-control.indicators.open-plural' | exp:'':'Abiertos')  }}</span>
            </div>
            <!-- Second card -->
            <div *tenantFeature="'provisionsControl.indicators.secondCard'" class="flex-column align-space-between-stretch bg-primary-lighter border-right px-16"
                style="flex: 1; border-radius: 0 0 0 6px;">
                <div class="flex-column align-space-between-stretch" style="height: 100%;">
                    <span class="subtitle flex align-center-start">{{ 'modules.schedule.provisional-control.indicators.cases-activity-period' | exp:'':'Casos abiertos y cerrados con actividad del' }} {{ this.getPeriod() }}</span>
                    <div class="flex align-center-stretch"
                        style="flex: 1 1 100%;box-sizing: border-box;place-content: center;align-items: center;flex-direction: row;max-height: 45%;"
                        *ngFor="let indicator of this.caseIndicators">
                        <app-theme-card themeScope="provisional-control" [fullWidth]="false" cardClass="indicators-totals"
                            [cardStyle]="{ 'white-space': 'nowrap', cursor: this.isLoadingProvisionalControlIndicators ? 'default' : 'pointer' }"
                            (cardClick)="!this.isLoadingProvisionalControlIndicators ? this.onClickCardIndicator(indicator.indicatorState) : null">
                            <mat-card-content style="height: 100%;">
                                <div class="flex-row align-start-center" style="height: 100% !important;
                                flex-direction: row;
                                box-sizing: border-box;
                                display: flex;
                                place-content: center;
                                align-items: stretch; width: 100%;">
                                    <span class="mat-display-1 number-font medium-number mb-0 mxs-2"
                                        *ngIf="!this.isLoadingProvisionalControlIndicators; else loadingIndicators"
                                        [ngClass]="indicator.color">
                                        {{ indicator.counter }}
                                    </span>
                                    <div class="flex-column align-center-start">
                                        <span class="text-primary-darker subtitle-2">{{ this.getIndicatorLabel(indicator) }}</span>
                                    </div>
                                </div>
                            </mat-card-content>
                        </app-theme-card>
                    </div>
                </div>
            </div>
            <ng-template #loadingIndicators>
                <mat-spinner class="mr-3" color="primary" diameter="25">
                </mat-spinner>
            </ng-template>
            <!-- Third card -->
            <div class="flex-column align-space-between-stretch border-right px-16 bg-provisional-practices" style="flex: 1;">
                <span class="subtitle flex align-center-center">{{ 'modules.schedule.provisional-control.indicators.practices-activity-period' | exp:'':'Prácticas con actividad del' }} {{ this.getPeriod() }}</span>
                <div class="flex-column align-space-between-none">
                    <!-- Sub-card 1 -->
                    <div class="align-center-center">
                        <app-theme-card themeScope="provisional-control" [fullWidth]="false" cardClass="indicators-totals my-2"
                            [cardStyle]="{ cursor: this.isLoadingProvisionalControlIndicators ? 'default' : 'pointer' }"
                            (cardClick)="!this.isLoadingProvisionFeesIndicators ? loadProvisionFees(provisionalControlProvisionFeeStates.ALL) : null">
                            <mat-card-content>
                                <div class="flex-row align-start-center">
                                    <span class="mat-display-1 number-font medium-number mb-0 mxs-2"
                                        *ngIf="!this.isLoadingProvisionFeesIndicators; else loadingIndicators">
                                        {{ counterProvisionFeesTotals }}
                                    </span>
                                    <span class="text-primary-darker subtitle-1">{{ 'modules.schedule.provisional-control.indicators.total-practices' | exp:'':'Total prácticas' }}</span>
                                </div>
                            </mat-card-content>
                        </app-theme-card>
                    </div>
                    <!-- Sub-card 2 -->
                    <div class="align-center-center">
                        <app-theme-card themeScope="provisional-control" [fullWidth]="false" cardClass="shadow-lg my-2"
                            [cardStyle]="{ 'white-space': 'nowrap', cursor: this.isLoadingProvisionalControlIndicators ? 'default' : 'pointer' }"
                            (cardClick)="!this.isLoadingProvisionFeesIndicators ? this.loadProvisionFees(provisionalControlProvisionFeeStates.NOT_AUTHORIZED) : null">
                            <mat-card-content>
                                <div class="flex-row align-start-center">
                                    <span class="mat-display-1 number-font small-number mb-0 label-1 mxs-2"
                                        style="flex: 0 1 20%"
                                        *ngIf="!this.isLoadingProvisionFeesIndicators; else loadingIndicators">
                                        {{ counterProvisionFeesNotAuthorized }}
                                    </span>
                                    <span class="text-primary-darker">{{ 'modules.schedule.provisional-control.indicators.not-authorized' | exp:'':'No autorizadas' }}</span>
                                </div>
                            </mat-card-content>
                        </app-theme-card>
                    </div>
                    <!-- Sub-card 3 -->
                    <div class="align-center-center">
                        <app-theme-card themeScope="provisional-control" [fullWidth]="false" cardClass="shadow-lg my-2"
                            [cardStyle]="{ 'white-space': 'nowrap', cursor: this.isLoadingProvisionalControlIndicators ? 'default' : 'pointer' }"
                            (cardClick)="!this.isLoadingProvisionFeesIndicators ? this.loadProvisionFees(provisionalControlProvisionFeeStates.WITHOUT_SCHEDULE) : null">
                            <mat-card-content>
                                <div class="flex-row align-start-center">
                                    <span class="mat-display-1 number-font small-number mb-0 label-1 mxs-2"
                                        style="flex: 0 1 20%"
                                        *ngIf="!this.isLoadingProvisionFeesIndicators; else loadingIndicators">
                                        {{ counterProvisionFeesWithoutSchedule }}
                                    </span>
                                    <span class="text-primary-darker">{{ 'modules.schedule.provisional-control.indicators.without-schedule' | exp:'':'Sin agenda' }}</span>
                                </div>
                            </mat-card-content>
                        </app-theme-card>
                    </div>
                    <!-- Sub-card 4 -->
                    <div *tenantFeature="'provisionsControl.indicators.thirdCard.subCardFour'" class="align-center-center">
                        <app-theme-card themeScope="provisional-control" [fullWidth]="false" cardClass="shadow-lg my-2"
                            [cardStyle]="{ 'white-space': 'nowrap', cursor: this.isLoadingProvisionalControlIndicators ? 'default' : 'pointer' }"
                            (cardClick)="!this.isLoadingProvisionFeesIndicators ? this.loadProvisionFees(provisionalControlProvisionFeeStates.BUDGETED) : null">
                            <mat-card-content>
                                <div class="flex-row align-start-center">
                                    <span class="mat-display-1 number-font small-number mb-0 label-1 mxs-2"
                                        style="flex: 0 1 20%"
                                        *ngIf="!this.isLoadingProvisionalControlIndicators; else loadingIndicators">
                                        {{ counterProvisionFeesBudgeted }}
                                    </span>
                                    <span class="text-primary-darker">{{ 'modules.schedule.provisional-control.indicators.budgeted-feminine' | exp:'':'Presupuestadas' }}</span>
                                </div>
                            </mat-card-content>
                        </app-theme-card>
                    </div>
                    <!-- Sub-card 5 -->
                    <div class="align-center-center">
                        <mat-card class="shadow-lg my-2" style="white-space: nowrap; cursor: pointer"
                            (click)="!this.isLoadingProvisionFeesIndicators ? this.loadProvisionFees(provisionalControlProvisionFeeStates.MODULES_WITHOUT_BILLING_ATTENTIONS) : null"
                            [ngStyle]="{'cursor': this.isLoadingProvisionFeesIndicators ? 'default' : 'pointer'}">
                            <mat-card-content>
                                <div class="flex-row align-start-center">
                                    <span class="mat-display-1 number-font small-number mb-0 label-1 mxs-2"
                                        style="flex: 0 1 20%"
                                        *ngIf="!this.isLoadingProvisionFeesIndicators; else loadingIndicators">
                                        {{ counterModulesWithoutBillingAttentions }}
                                    </span>
                                    <span class="text-primary-darker">{{ 'modules.schedule.provisional-control.indicators.modules-without-billing-attentions' | exp:'':'Modulos sin atenciones de facturacion' }}</span>
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </div>
                </div>
            </div>
            <!-- Fourth card -->
            <div class="flex-column align-space-between-stretch px-16 bg-provisional-practices" style="flex: 1">
                <span class="subtitle flex align-center-center">{{ 'modules.schedule.provisional-control.indicators.supplies-activity-period' | exp:'':'Insumos con actividad del' }} {{ this.getPeriod() }}</span>
                <div class="flex-column align-space-between-none">
                    <!-- Sub-card 1 -->
                    <div class="align-center-center">
                        <app-theme-card themeScope="provisional-control" [fullWidth]="false" cardClass="indicators-totals my-2"
                            [cardStyle]="{ cursor: this.isLoadingProvisionalControlIndicators ? 'default' : 'pointer' }"
                            (cardClick)="!this.isLoadingOrderIndicators ? loadOrders(this.provisionalControlOrderStates.ALL) : null">
                            <mat-card-content>
                                <div class="flex-row align-start-center">
                                    <span class="mat-display-1 number-font medium-number mb-0 mxs-2"
                                        *ngIf="!this.isLoadingOrderIndicators; else loadingIndicators">
                                        {{ counterTotalOrders }}
                                    </span>
                                    <span class="text-primary-darker subtitle-1">{{ 'modules.schedule.provisional-control.indicators.total-orders' | exp:'':'Total pedidos' }}</span>
                                </div>
                            </mat-card-content>
                        </app-theme-card>
                    </div>
                    <!-- Sub-card 2 -->
                    <div class="align-center-center">
                        <app-theme-card themeScope="provisional-control" [fullWidth]="false" cardClass="shadow-lg my-2"
                            [cardStyle]="{ 'white-space': 'nowrap', cursor: this.isLoadingProvisionalControlIndicators ? 'default' : 'pointer' }"
                            (cardClick)="!this.isLoadingProvisionalControlIndicators ? onClickCardIndicator(provisionalControlIndicatorsStates.CON_INSUMOS_NO_PEDIDOS) : null">
                            <mat-card-content>
                                <div class="flex-row align-start-center">
                                    <span class="mat-display-1 number-font small-number mb-0 label-1 mxs-2"
                                        *ngIf="!this.isLoadingProvisionalControlIndicators; else loadingIndicators"
                                        [style.color]="this.colorInformableIndicator">
                                        {{ counterCasesWithNotOrderedSupplies }}
                                    </span>
                                    <div class="flex-column align-start-center">
                                        <span class="text-primary-darker">{{ 'modules.schedule.provisional-control.indicators.cases-with-not-ordered-supplies' | exp:'':'Casos con insumos no pedidos' }}</span>
                                    </div>
                                </div>
                            </mat-card-content>
                        </app-theme-card>
                    </div>
                    <!-- Sub-card 3 -->
                    <div class="align-center-center">
                        <app-theme-card themeScope="provisional-control" [fullWidth]="false" cardClass="shadow-lg my-2"
                            [cardStyle]="{ 'white-space': 'nowrap', cursor: this.isLoadingProvisionalControlIndicators ? 'default' : 'pointer' }"
                            (cardClick)="!this.isLoadingOrderIndicators ? this.loadOrders(provisionalControlOrderStates.WITH_NOT_AUTHORIZED_SUPPLIES) : null">
                            <mat-card-content>
                                <div class="flex-row align-start-center">
                                    <span class="mat-display-1 number-font small-number mb-0 label-1 mxs-2"
                                        *ngIf="!this.isLoadingOrderIndicators; else loadingIndicators">
                                        {{ counterOrdersWithNotAuthorizedSupplies }}
                                    </span>
                                    <span class="text-primary-darker">{{ 'modules.schedule.provisional-control.indicators.orders-with-not-authorized-supplies' | exp:'':'Pedidos con insumos no autorizados' }}</span>
                                </div>
                            </mat-card-content>
                        </app-theme-card>
                    </div>
                    <!-- Sub-card 4 -->
                    <div class="align-center-center">
                        <app-theme-card themeScope="provisional-control" [fullWidth]="false" cardClass="shadow-lg my-2"
                            [cardStyle]="{ 'white-space': 'nowrap', cursor: this.isLoadingProvisionalControlIndicators ? 'default' : 'pointer' }"
                            (cardClick)="!this.isLoadingOrderIndicators ? this.loadOrders(provisionalControlOrderStates.NOT_DELIVERED) : null">
                            <mat-card-content>
                                <div class="flex-row align-start-center">
                                    <span class="mat-display-1 number-font small-number mb-0 label-1 mxs-2"
                                        *ngIf="!this.isLoadingOrderIndicators; else loadingIndicators">
                                        {{ counterOrdersNotDelivered }}
                                    </span>
                                    <span class="text-primary-darker">{{ 'modules.schedule.provisional-control.indicators.orders-not-delivered' | exp:'':'Pedidos no entregados' }}</span>
                                </div>
                            </mat-card-content>
                        </app-theme-card>
                    </div>
                </div>
            </div>
        </div>

        <div class="flex-row flex-100 border-table-cases" data-theme-scope="provisional-control">
            <div class="example-loading-shade"
                *ngIf="isLoadingGettingCases || isLoadingGettingOrders || isLoadingGettingProvisionFees">
                <app-spinner></app-spinner>
            </div>
            <div class="flex-100 flex-column">
                <div class="flex-column">
                    <div class="flex-row flex-100 flex-gap-1rem pt-1 px-1">
                        <span class="flex-10 mxs-1 subtitle-3 pb-2 text-ellipsis"
                            *ngIf="!!this.financier && !!this.metaDataCases?.financierId && !!this.dateTo">
                            {{ ('modules.schedule.provisional-control.status.before-date-of-financier' | exp:{date: (this.dateTo | date: 'dd/MM/yyyy'), financier: (this.getActualFinancierName(financiers) | titlecase)}:'Estado de casos con actividades previas al ' + (this.dateTo | date: 'dd/MM/yyyy') + ' de ' + (this.getActualFinancierName(financiers) | titlecase)) }}
                        </span>
                        <span class="flex-20 mxs-1 subtitle-3 pb-2 text-ellipsis"
                            *ngIf="!!this.financier && !!this.metaDataCases?.financierId && !this.dateTo">
                            {{ ('modules.schedule.provisional-control.status.activities-of-financier' | exp:{financier: (this.getActualFinancierName(financiers) | titlecase)}:'Estado de casos con actividades de ' + (this.getActualFinancierName(financiers) | titlecase)) }}
                        </span>
                        <span class="flex-20 mxs-1 subtitle-3 pb-2 text-ellipsis"
                            *ngIf="(!this.financier || !this.metaDataCases?.financierId) && !!this.dateTo">
                            {{ ('modules.schedule.provisional-control.status.before-date' | exp:{date: (this.dateTo | date: 'dd/MM/yyyy')}:'Estado de casos con actividades previas al ' + (this.dateTo | date: 'dd/MM/yyyy')) }}
                        </span>
                        <mat-form-field appearance="outline" class="flex-row flex-50 mls-1">
                            <mat-label>
                                {{ 'modules.schedule.provisional-control.search.placeholder' | exp:'':'Ingrese nombre, apellido, DNI o CIF del paciente' }}
                            </mat-label>
                            <input matInput #inputSearch />
                        </mat-form-field>
                        <!-- Casos, Pedidos, Prácticas -->
                        <app-select-input [elements]="this.tableOptions" [name]="this.PROVISIONAL_OPTIONS"
                            [form]="this.filterForm" style="flex: 1 1 20%" [placeholder]="('modules.schedule.provisional-control.filters.by-indicator' | exp:'':'Filtrar por indicador')"
                            [calculateId]="calculateIdTableOptions" [calculateName]="calculateNameTableOptions"
                            [defaultValue]="this.optionSelected.toString()" (selected)="onSelectTableOption()">
                        </app-select-input>
                        <!-- Todos, Abiertos, Cerrados, Rechazados -->
                        @if(this.optionSelected === ProvisionalControlTableOptions.CASES) {
                        <app-select-input [elements]="this.casesStates" [name]="this.CASES_STATES"
                            [form]="this.filterForm" style="flex: 1 1 20%" [placeholder]="('modules.schedule.provisional-control.filters.by-indicator' | exp:'':'Filtrar por indicador')"
                            [calculateId]="calculateIdCaseState" [calculateName]="calculateNameCaseState"
                            [defaultValue]="" (selected)="onFilterV2(false, this.globalVersion)">
                        </app-select-input>
                        }
                        <!-- Todos, Operables, Informables, Con insumos..., Informados -->
                        @if(this.optionSelected === ProvisionalControlTableOptions.CASES) {
                        <app-select-input [elements]="this.filteredProvisionalControlIndicators"
                            [name]="this.PROVISIONAL_STATE" [form]="this.filterForm" style="flex: 1 1 20%"
                            [placeholder]="('modules.schedule.provisional-control.filters.by-indicator' | exp:'':'Filtrar por indicador')" [calculateId]="calculateIdIndicatorState"
                            [calculateName]="calculateNameIndicatorState"
                            [defaultValue]="this.indicatorStateSelected?.id.toString()"
                            (selected)="onSelectIndicatorFilter($event)">
                        </app-select-input>
                        }
                        <!-- Orders -->
                        @if(this.optionSelected === ProvisionalControlTableOptions.ORDERS) {
                        <app-select-input [elements]="this.orderStates" [name]="this.ORDER_STATES"
                            [form]="this.filterForm" style="flex: 1 1 20%" [placeholder]="('modules.schedule.provisional-control.filters.by-indicator' | exp:'':'Filtrar por indicador')"
                            [calculateId]="calculateIdIndicatorState" [calculateName]="calculateNameIndicatorState"
                            [defaultValue]="this.orderStateSelected?.toString()" (selected)="loadOrders($event)">
                        </app-select-input>
                        }
                        <!-- ProvisionFees -->
                        @if(this.optionSelected === ProvisionalControlTableOptions.PROVISIONFEES) {
                        <app-select-input [elements]="this.provisionFeeStates" [name]="this.PROVISIONFEE_STATES"
                            [form]="this.filterForm" style="flex: 1 1 20%" [placeholder]="('modules.schedule.provisional-control.filters.by-indicator' | exp:'':'Filtrar por indicador')"
                            [calculateId]="calculateIdIndicatorState" [calculateName]="calculateNameIndicatorState"
                            [defaultValue]="this.provisionFeeStateSelected?.toString()" (selected)="loadProvisionFees($event)">
                        </app-select-input>
                        }
                            @if(isLoadingGettingAllCasesXLS){
                            <div class="mr-2 pts-3 pbs-3">
                                <mat-spinner color="primary" diameter="15">
                                </mat-spinner>
                            </div>
                            }@else {
                            <button  mat-icon-button [matMenuTriggerFor]="menuGlobalActions"
                                (click)="$event.stopPropagation()" [matTooltip]="('modules.schedule.provisional-control.actions.menu-tooltip' | exp:'':'Acciones')">
                                <mat-icon class="cursor-pointer text-secondary"
                                    [svgIcon]="'DotsThreeVertical-enabled-primary-lighter'"></mat-icon>
                            </button>
                            }
                    </div>
                    <!-- [ngClass.lt-sm]="{ 'cases-container': true }" -->
                    <div class="table-container p-0">
                        <!-- Deleted because order by observable matSortDirection="asc" -->
                        <!-- [ngClass.lt-md]="{ 'cases-table': true }" -->
                        <table mat-table class="mat-elevation-z0"
                            *ngIf="optionSelected == ProvisionalControlTableOptions.CASES" [dataSource]="dataSource"
                            matSort matSortActive="patient" (matSortChange)="onSortEvent($event)" matSortDisableClear>
                            <!-- financier Column -->
                            <ng-container matColumnDef="financier" sticky>
                                <th mat-header-cell *matHeaderCellDef class="bg-primary-lighter">{{ 'modules.schedule.provisional-control.table.financier-cif' | exp:'':'Financiador / CIF' }}</th>
                                <td mat-cell *matCellDef="let case">
                                    <div class="inner-cell">
                                        <div class="flex-column"> <span
                                                [matTooltip]="!!case.financier && !!case.financier.name ? case.financier.name : ('modules.schedule.provisional-control.table.no-data' | exp:'':'Sin datos')">
                                                {{ !!case.financier && !!case.financier.name ?
                                                this.generalService.getSummarizeString(case.financier.name,20) :
                                                ('modules.schedule.provisional-control.table.no-data' | exp:'':'Sin datos')
                                                }}
                                            </span>
                                            <span *ngIf="!!case.financierInternalCode || case.patient?.documentNumber"
                                                [matTooltip]="('modules.schedule.provisional-control.table.financier-internal-code-tooltip' | exp:'':'Código interno de financiador')" class="text-secondary">
                                                #{{ !!case.financierInternalCode ? case.financierInternalCode :
                                                case.patient?.documentNumber}}
                                            </span>
                                        </div>
                                    </div>
                                </td>
                            </ng-container>

                            <!-- Active Column -->
                            <ng-container matColumnDef="active">
                                <th mat-header-cell *matHeaderCellDef></th>
                                <td mat-cell *matCellDef="let case">
                                    <div class="inner-cell active-column">
                                        <div class="flex-column"> <mat-icon class="text-warn" *ngIf="case.isDerivedTo"
                                                [matTooltip]="('modules.schedule.provisional-control.table.case-derived-to' | exp:{name: case.caseDerivation?.derivedTo?.name}:'Caso derivado a: ' + case.caseDerivation?.derivedTo?.name)">
                                                redo
                                            </mat-icon>
                                            <mat-icon class="text-primary" *ngIf="case.isDerived"
                                                [matTooltip]="('modules.schedule.provisional-control.table.case-derived-from' | exp:{name: case.caseDerivation?.derivedFrom?.name}:'Caso derivado de: ' + case.caseDerivation?.derivedFrom?.name)">
                                                undo
                                            </mat-icon>
                                            <mat-icon
                                                [ngClass]="{'text-primary': !case.legacyId,'text-secondary': !!case.legacyId}"
                                                *ngIf="case.active" [matTooltip]="('modules.schedule.provisional-control.table.case-active' | exp:'':'Caso activo')">
                                                check_circle
                                            </mat-icon>
                                            <mat-icon class="text-warn mbs-1" *ngIf="!case.active"
                                                [matTooltip]="('modules.schedule.provisional-control.table.case-inactive' | exp:'':'Caso inactivo')">
                                                highlight_off
                                            </mat-icon>
                                        </div>
                                    </div>
                                </td>
                            </ng-container>

                            <!-- operator.name Column -->
                            <ng-container matColumnDef="operator">
                                <th mat-header-cell *matHeaderCellDef class="bg-primary-lighter">{{ 'modules.schedule.provisional-control.table.operator' | exp:'':'Operador' }}</th>
                                <td mat-cell *matCellDef="let case">
                                    <div class="inner-cell">
                                        {{ case.operator?.name }}
                                    </div>
                                </td>
                            </ng-container>

                            <!-- patient.surname Column -->
                            <ng-container matColumnDef="patient">
                                <th mat-header-cell *matHeaderCellDef class="bg-primary-lighter"
                                    mat-sort-header="surname" sortActionDescription="{{ 'modules.schedule.provisional-control.table.patient' | exp:'':'Paciente' }}">{{'modules.schedule.provisional-control.table.patient' | exp:'':'Paciente'}}</th>
                                <td mat-cell *matCellDef="let case">
                                    <div class="inner-cell"
                                        style="text-align: start !important; justify-content: start !important; padding-left: 10px;">
                                        <span [matTooltip]="getLastStateTooltip(case)">
                                            {{ this.generalService.getFullName( case.patient.name,
                                            case.patient.surname ) | titlecase}}
                                        </span>
                                    </div>
                                </td>
                            </ng-container>

                            <!-- patiten.documentNumber Column -->
                            <ng-container matColumnDef="patientDocument">
                                <th mat-header-cell *matHeaderCellDef class="bg-primary-lighter">{{ 'modules.schedule.provisional-control.table.patient-dni' | exp:'':'DNI Paciente' }}</th>
                                <td mat-cell *matCellDef="let case">
                                    <div class="inner-cell">
                                        <span>
                                            {{ case?.patient?.documentNumber ? case?.patient?.documentNumber : ('modules.schedule.provisional-control.table.no-data' | exp:'':'Sin datos') }}
                                        </span>
                                    </div>
                                </td>
                            </ng-container>

                            <!-- DNI Column -->
                            <ng-container matColumnDef="companyType">
                                <th mat-header-cell *matHeaderCellDef class="bg-primary-lighter">{{ 'modules.schedule.provisional-control.filters.company-type' | exp:'':'Tipo de empresa' }}</th>
                                <td mat-cell *matCellDef="let case">
                                    <div class="inner-cell">
                                        <span>
                                            {{ (case.companyType) ? case.companyType.description : ('modules.schedule.provisional-control.table.no-data' | exp:'':'Sin datos') }}
                                        </span>
                                    </div>
                                </td>
                            </ng-container>

                            <!-- Case type Column -->
                            <ng-container matColumnDef="caseType">
                                <th mat-header-cell *matHeaderCellDef>
                                    <span>{{ 'modules.schedule.provisional-control.table.case-type' | exp:'':'Tipo de caso' }}</span>
                                </th>
                                <td mat-cell *matCellDef="let case">
                                    <div class="inner-cell case-type-cell align-center-center"
                                        matTooltip="{{getCaseTypesList(case.caseTags, '  •  ')}}">
                                        <div>
                                            <span class="text-ellipsis">{{getCaseTypesList(case.caseTags, ', ')}}</span>
                                        </div>
                                    </div>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="complexity">
                                <th mat-header-cell *matHeaderCellDef class="bg-primary-lighter">{{ 'modules.schedule.provisional-control.table.complexity' | exp:'':'Complejidad' }}</th>
                                <td mat-cell *matCellDef="let case">
                                    <div class="inner-cell">
                                        <span>
                                            {{ !!case.complexities ? case.complexities.name : '-' }}
                                        </span>
                                    </div>
                                </td>
                            </ng-container>

                            <!-- ExpiredAuthorizations Column -->
                            <ng-container matColumnDef="expiredAuthorizations">
                                <th mat-header-cell *matHeaderCellDef class="bg-primary-lighter">{{ 'modules.schedule.provisional-control.table.authorizations' | exp:'':'Autorizaciones' }}</th>
                                <td mat-cell *matCellDef="let case">
                                    <div class="inner-cell">
                                        <mat-chip-listbox *ngIf="!case?.isLoadingStates">
                                            <mat-chip style="white-space: nowrap; cursor: pointer"
                                                [ngStyle]="{ 'background-color': this.getBackgroundColorAuthorizationState(case.closestAuthorizationState), 'color': this.getColorAuthorizationState(case.closestAuthorizationState) }"
                                                selected>
                                                <span class="mat-small">
                                                    {{ this.getAuthorizationState(case.closestAuthorizationState, case)
                                                    }}
                                                </span>
                                            </mat-chip>
                                        </mat-chip-listbox>
                                    </div>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                            <tr mat-row [matTooltip]="('modules.schedule.provisional-control.table.view-case-details' | exp:'':'Ver detalles del caso')" [matTooltipShowDelay]="2000"
                                *matRowDef="let row; columns: displayedColumns" class="bg-on-hover"
                                (click)="onClickRow(row)" style="cursor: pointer;">
                            </tr>
                        </table>
                        <!-- [ngClass.lt-md]="{ 'cases-table': true }" -->
                        <!--ORDERS TABLE-->
                        <table mat-table class="mat-elevation-z0 flex-100"
                            *ngIf="optionSelected == ProvisionalControlTableOptions.ORDERS" [dataSource]="orders"
                            matSort matSortActive="patient" (matSortChange)="onSortEvent($event)" matSortDisableClear>
                            <!-- financier Column -->
                            <ng-container matColumnDef="orderFinancier" sticky>
                                <th mat-header-cell *matHeaderCellDef class="bg-primary-lighter">{{ 'modules.schedule.provisional-control.table.financier-cif' | exp:'':'Financiador / CIF' }}</th>
                                <td mat-cell *matCellDef="let order">
                                    <div class="inner-cell">
                                        <div class="flex-column"> <span
                                                [matTooltip]="!!order.casee?.financier && !!order.casee?.financier.name ? order.casee?.financier.name : ('modules.schedule.provisional-control.table.no-data' | exp:'':'Sin datos')">
                                                {{ !!order.casee?.financier && !!order.casee?.financier.name ?
                                                this.generalService.getSummarizeString(order.casee?.financier.name,20) :
                                                ('modules.schedule.provisional-control.table.no-data' | exp:'':'Sin datos') }}
                                            </span>
                                            <span
                                                *ngIf="!!order.casee?.financierInternalCode || order.casee?.patient?.documentNumber"
                                                [matTooltip]="('modules.schedule.provisional-control.table.financier-internal-code-tooltip' | exp:'':'Código interno de financiador')" class="text-secondary">
                                                #{{ !!order.casee?.financierInternalCode ?
                                                order.casee?.financierInternalCode :
                                                order.casee?.patient?.documentNumber}}
                                            </span>
                                        </div>
                                    </div>
                                </td>
                            </ng-container>

                            <!-- Active Column -->
                            <ng-container matColumnDef="orderCaseActive">
                                <th mat-header-cell *matHeaderCellDef></th>
                                <td mat-cell *matCellDef="let order">
                                    <div class="inner-cell active-column">
                                        <div class="flex-column"> <mat-icon class="text-warn"
                                                *ngIf="order.casee?.isDerivedTo"
                                                [matTooltip]="('modules.schedule.provisional-control.table.case-derived-to' | exp:{name: order.casee?.caseDerivation?.derivedTo?.name}:'Caso derivado a: ' + order.casee?.caseDerivation?.derivedTo?.name)">
                                                redo
                                            </mat-icon>
                                            <mat-icon class="text-primary" *ngIf="order.casee?.isDerived"
                                                [matTooltip]="('modules.schedule.provisional-control.table.case-derived-from' | exp:{name: order.casee?.caseDerivation?.derivedFrom?.name}:'Caso derivado de: ' + order.casee?.caseDerivation?.derivedFrom?.name)">
                                                undo
                                            </mat-icon>
                                            <mat-icon
                                                [ngClass]="{'text-primary': !order.casee?.legacyId,'text-secondary': !!order.casee?.legacyId}"
                                                *ngIf="order.casee?.active" [matTooltip]="('modules.schedule.provisional-control.table.case-active' | exp:'':'Caso activo')">
                                                check_circle
                                            </mat-icon>
                                            <mat-icon class="text-warn mbs-1" *ngIf="!order.casee?.active"
                                                [matTooltip]="('modules.schedule.provisional-control.table.case-inactive' | exp:'':'Caso inactivo')">
                                                highlight_off
                                            </mat-icon>
                                        </div>
                                    </div>
                                </td>
                            </ng-container>

                            <!-- operator.name Column -->
                            <ng-container matColumnDef="orderOperator">
                                <th mat-header-cell *matHeaderCellDef class="bg-primary-lighter">{{ 'modules.schedule.provisional-control.table.operator' | exp:'':'Operador' }}</th>
                                <td mat-cell *matCellDef="let order">
                                    <div class="inner-cell">
                                        {{ order.casee?.operator?.name }}
                                    </div>
                                </td>
                            </ng-container>

                            <!-- patient.surname Column -->
                            <ng-container matColumnDef="orderPatient">
                                <th mat-header-cell *matHeaderCellDef class="bg-primary-lighter"
                                    mat-sort-header="surname" sortActionDescription="{{ 'modules.schedule.provisional-control.table.patient' | exp:'':'Paciente' }}">{{'modules.schedule.provisional-control.table.patient' | exp:'':'Paciente'}}</th>
                                <td mat-cell *matCellDef="let order">
                                    <div class="inner-cell"
                                        style="text-align: start !important; justify-content: start !important; padding-left: 10px;">
                                        <span>
                                            {{ this.generalService.getFullName( order.casee?.patient.name,
                                            order.casee?.patient.surname ) | titlecase }}
                                        </span>
                                    </div>
                                </td>
                            </ng-container>

                            <!-- patiten.documentNumber Column -->
                            <ng-container matColumnDef="orderPatientDocument">
                                <th mat-header-cell *matHeaderCellDef class="bg-primary-lighter">{{ 'modules.schedule.provisional-control.table.patient-dni' | exp:'':'DNI Paciente' }}</th>
                                <td mat-cell *matCellDef="let order">
                                    <div class="inner-cell">
                                        <span>
                                            {{ order.casee?.patient?.documentNumber ?
                                            order.casee?.patient?.documentNumber : ('modules.schedule.provisional-control.table.no-data' | exp:'':'Sin datos') }}
                                        </span>
                                    </div>
                                </td>
                            </ng-container>

                            <!-- COMPANY TYPE Column -->
                            <ng-container matColumnDef="orderCompanyType">
                                <th mat-header-cell *matHeaderCellDef class="bg-primary-lighter">{{ 'modules.schedule.provisional-control.filters.company-type' | exp:'':'Tipo de empresa' }}</th>
                                <td mat-cell *matCellDef="let order">
                                    <div class="inner-cell">
                                        <span>
                                            {{ (order.casee?.companyType) ? order.casee?.companyType.description : ('modules.schedule.provisional-control.table.no-data' | exp:'':'Sin datos') }}
                                        </span>
                                    </div>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="orderId">
                                <th mat-header-cell *matHeaderCellDef class="bg-primary-lighter">{{ 'modules.schedule.provisional-control.table.order-number' | exp:'':'Pedido número' }}</th>
                                <td mat-cell *matCellDef="let order">
                                    <div class="inner-cell">
                                        <span>
                                            {{ (order?.id) ? order?.id : ('modules.schedule.provisional-control.table.no-data' | exp:'':'Sin datos') }}
                                        </span>
                                    </div>
                                </td>
                            </ng-container>


                            <tr mat-header-row *matHeaderRowDef="displayedColumnsOrders; sticky: true"></tr>
                            <tr mat-row [matTooltip]="('modules.schedule.provisional-control.table.view-case-details' | exp:'':'Ver detalles del caso')" [matTooltipShowDelay]="2000"
                                *matRowDef="let row; columns: displayedColumnsOrders" class="bg-on-hover"
                                (click)="onClickRow(row)" style="cursor: pointer;">
                            </tr>
                        </table>
                        <!-- [ngClass.lt-md]="{ 'cases-table': true }" -->
                        <!--PRACTICES TABLE-->
                        <table mat-table class="mat-elevation-z0"
                            *ngIf="this.optionSelected == ProvisionalControlTableOptions.PROVISIONFEES"
                            ngClass="flex-100" [dataSource]="provisionFees" matSort matSortActive="patient"
                            (matSortChange)="onSortEvent($event)" matSortDisableClear>

                            <!-- financier Column -->
                            <ng-container matColumnDef="practiceFinancier" sticky>
                                <th mat-header-cell *matHeaderCellDef class="bg-primary-lighter">{{ 'modules.schedule.provisional-control.table.financier-cif' | exp:'':'Financiador / CIF' }}</th>
                                <td mat-cell *matCellDef="let provisionFee">
                                    <div class="inner-cell">
                                        <div class="flex-column"> <span
                                                [matTooltip]="!!provisionFee.casee?.financier && !!provisionFee.casee?.financier.name ? provisionFee.casee?.financier.name : ('modules.schedule.provisional-control.table.no-data' | exp:'':'Sin datos')">
                                                {{ !!provisionFee.casee?.financier &&
                                                !!provisionFee.casee?.financier.name ?
                                                this.generalService.getSummarizeString(provisionFee.casee?.financier.name,20)
                                                : ('modules.schedule.provisional-control.table.no-data' | exp:'':'Sin datos') }}
                                            </span>
                                            <span
                                                *ngIf="!!provisionFee.casee?.financierInternalCode || provisionFee.casee?.patient?.documentNumber"
                                                [matTooltip]="('modules.schedule.provisional-control.table.financier-internal-code-tooltip' | exp:'':'Código interno de financiador')" class="text-secondary">
                                                #{{ !!provisionFee.casee?.financierInternalCode ?
                                                provisionFee.casee?.financierInternalCode :
                                                provisionFee.casee?.patient?.documentNumber}}
                                            </span>
                                        </div>
                                    </div>
                                </td>
                            </ng-container>

                            <!-- Active Column -->
                            <ng-container matColumnDef="practiceCaseActive">
                                <th mat-header-cell *matHeaderCellDef></th>
                                <td mat-cell *matCellDef="let provisionFee">
                                    <div class="inner-cell active-column">
                                        <div class="flex-column"> <mat-icon class="text-warn"
                                                *ngIf="provisionFee.casee?.isDerivedTo"
                                                [matTooltip]="('modules.schedule.provisional-control.table.case-derived-to' | exp:{name: provisionFee.casee?.caseDerivation?.derivedTo?.name}:'Caso derivado a: ' + provisionFee.casee?.caseDerivation?.derivedTo?.name)">
                                                redo
                                            </mat-icon>
                                            <mat-icon class="text-primary" *ngIf="provisionFee.casee?.isDerived"
                                                [matTooltip]="('modules.schedule.provisional-control.table.case-derived-from' | exp:{name: provisionFee.casee?.caseDerivation?.derivedFrom?.name}:'Caso derivado de: ' + provisionFee.casee?.caseDerivation?.derivedFrom?.name)">
                                                undo
                                            </mat-icon>
                                            <mat-icon
                                                [ngClass]="{'text-primary': !provisionFee.casee?.legacyId,'text-secondary': !!provisionFee.casee?.legacyId}"
                                                *ngIf="provisionFee.casee?.active" [matTooltip]="('modules.schedule.provisional-control.table.case-active' | exp:'':'Caso activo')">
                                                check_circle
                                            </mat-icon>
                                            <mat-icon class="text-warn mbs-1" *ngIf="!provisionFee.casee?.active"
                                                [matTooltip]="('modules.schedule.provisional-control.table.case-inactive' | exp:'':'Caso inactivo')">
                                                highlight_off
                                            </mat-icon>
                                        </div>
                                    </div>
                                </td>
                            </ng-container>

                            <!-- operator.name Column -->
                            <ng-container matColumnDef="practiceOperator">
                                <th mat-header-cell *matHeaderCellDef class="bg-primary-lighter">{{ 'modules.schedule.provisional-control.table.operator' | exp:'':'Operador' }}</th>
                                <td mat-cell *matCellDef="let provisionFee">
                                    <div class="inner-cell">
                                        {{ provisionFee.casee?.operator?.name }}
                                    </div>
                                </td>
                            </ng-container>

                            <!-- patient.surname Column -->
                            <ng-container matColumnDef="practicePatient">
                                <th mat-header-cell *matHeaderCellDef class="bg-primary-lighter"
                                    mat-sort-header="surname" sortActionDescription="{{ 'modules.schedule.provisional-control.table.patient' | exp:'':'Paciente' }}">{{'modules.schedule.provisional-control.table.patient' | exp:'':'Paciente'}}</th>
                                <td mat-cell *matCellDef="let provisionFee">
                                    <div class="inner-cell"
                                        style="text-align: start !important; justify-content: start !important; padding-left: 10px;">
                                        <span>
                                            {{ this.generalService.getFullName( provisionFee.casee?.patient.name,
                                            provisionFee.casee?.patient.surname )}}
                                        </span>
                                    </div>
                                </td>
                            </ng-container>

                            <!-- COMPANY TYPE Column -->
                            <ng-container matColumnDef="practiceCompanyType">
                                <th mat-header-cell *matHeaderCellDef class="bg-primary-lighter">{{ 'modules.schedule.provisional-control.filters.company-type' | exp:'':'Tipo de empresa' }}</th>
                                <td mat-cell *matCellDef="let provisionFee">
                                    <div class="inner-cell">
                                        <span>
                                            {{ (provisionFee.casee?.companyType) ?
                                            provisionFee.casee?.companyType.description : ('modules.schedule.provisional-control.table.no-data' | exp:'':'Sin datos') }}
                                        </span>
                                    </div>
                                </td>
                            </ng-container>

                            <!-- PRACTICE Column -->
                            <ng-container matColumnDef="practiceName">
                                <th mat-header-cell *matHeaderCellDef class="bg-primary-lighter">{{ provisionFeeMainColumnLabel }}</th>
                                <td mat-cell *matCellDef="let provisionFee">
                                    <div class="inner-cell">
                                        <span [matTooltip]="getProvisionFeeMainName(provisionFee)" matTooltipPosition="above" style="text-overflow: ellipsis; max-width: 20ch; overflow: hidden; white-space: nowrap; display: inline-block;">
                                            {{ (getProvisionFeeMainName(provisionFee)) ? getProvisionFeeMainName(provisionFee) : ('modules.schedule.provisional-control.table.no-data' | exp:'':'Sin datos') }}
                                        </span>
                                    </div>
                                </td>
                            </ng-container>

                            <!-- VIGENCY Column -->
                            <ng-container matColumnDef="vigency">
                                <th mat-header-cell *matHeaderCellDef class="bg-primary-lighter">{{ 'modules.schedule.provisional-control.table.vigency' | exp:'':'Vigencia' }}</th>
                                <td mat-cell *matCellDef="let provisionFee">
                                    <div class="inner-cell">
                                        <span>
                                            {{ provisionFee.fromDate }}
                                            {{ !!provisionFee.toDate ? ' ' + ('modules.schedule.provisional-control.period.al' | exp:'':'al') + ' ' + provisionFee.toDate : ('modules.schedule.provisional-control.period.en-adelante' | exp:'':'en adelante') + '.' }}
                                        </span>
                                    </div>
                                </td>
                            </ng-container>

                            <!-- AUTHORIZATION Column -->
                            <ng-container matColumnDef="provisionFeeAuthorization">
                                <th mat-header-cell *matHeaderCellDef class="bg-primary-lighter">{{ 'modules.schedule.provisional-control.table.authorizations' | exp:'':'Autorizaciones' }}</th>
                                <td mat-cell *matCellDef="let provisionFee">
                                    <div class="inner-cell">
                                        <mat-chip-listbox>
                                            <mat-chip
                                                [ngStyle]="{ 'background-color': this.getBackgroundColorAuthorizationState(provisionFee), 'color': this.getColorAuthorizationState(provisionFee) }"
                                                matTooltip="{{provisionFee.authorization
                                                        ? '#' + provisionFee.authorization.authorizationNumber + ' - ' + this.generalService.getAuthorizationState(provisionFee.authorization)
                                                        : this.generalService.getAuthorizationState(provisionFee.authorization)}}"
                                                matBadge="P" [matBadgeHidden]="provisionFee.arrangement != null"
                                                matBadgeColor="accent" matBadgeSize="small">
                                                <span class="mat-small">
                                                    {{this.generalService.getAuthorizationState(provisionFee.authorization) |
                                                    firstLetterWordsIntoString}}
                                                </span>
                                            </mat-chip>
                                        </mat-chip-listbox>
                                    </div>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="displayedColumnsProvisionFees; sticky: true"></tr>
                            <tr mat-row [matTooltip]="('modules.schedule.provisional-control.table.view-case-details' | exp:'':'Ver detalles del caso')" [matTooltipShowDelay]="2000"
                                *matRowDef="let row; columns: displayedColumnsProvisionFees" class="bg-on-hover"
                                (click)="onClickRow(row)" style="cursor: pointer;">
                            </tr>
                        </table>
                        <!-- Paginator -->
                        <mat-paginator class="flex-100" pageSize="100" [pageSizeOptions]="[5, 10, 25, 50, 100]"
                            (page)="onPaginatorEvent()" showFirstLastButtons>
                        </mat-paginator>
                    </div>
                </div>

                <ng-template #noCasesTemplate>
                    <span class="flex-100 align-center-start text-secondary mts-4">
                        {{ 'modules.schedule.provisional-control.empty.no-cases' | exp:'':'No se encontraron casos con los filtros establecidos' }}
                    </span>
                </ng-template>
            </div>
        </div>

        <!-- Spinner -->
        <ng-template #loading>
            <div class="flex-100 mts-5 align-center-center">
                <app-spinner class="flex-100 align-center-start"></app-spinner>
            </div>
        </ng-template>

        <!-- Error message -->
        <ng-template #errorDiv>
            <div class="flex-100 align-center-center">
                <app-spinner-error></app-spinner-error>
                <span>{{ 'modules.schedule.provisional-control.errors.unexpected' | exp:'':'Ha ocurrido un error inesperado, inténtelo nuevamente' }}</span>
            </div>
        </ng-template>
    </div>
</div>


<mat-menu #menuGlobalActions="matMenu">
    <button mat-menu-item (click)="exportCasesOnXls()">{{ 'modules.schedule.provisional-control.actions.export-xls' | exp:'':'Exportar como .xls' }}</button>
</mat-menu>
